import * as React from 'react'

import { InvoiceScheduledEmailStatus } from '../../types'
import { classNames } from '../../utils'

interface Props {
  status: InvoiceScheduledEmailStatus
}

export default function InvoiceDeliveryStatusLabel(props: Props) {
  const { status } = props

  return (
    <span
      className={classNames(
        'whitespace-nowrap text-sm font-semibold uppercase leading-6',
        status === 'Unscheduled' && 'text-red-800/50',
        status === 'Scheduled' && 'text-slate-400/90',
        status === 'Running' && 'text-amber-600',
        status === 'Completed' && 'text-green-600',
        status === 'Failed' && 'text-rose-800',
      )}
    >
      {status}
    </span>
  )
}
